import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import { initTelemetry } from './lib/telemetry';
import './i18n/config';
import './index.css';

// Before render, so the very first API calls are correlated too (M0-29).
//
// ⚠️ The telemetry rule from M1-32's notes applies with force in this app:
// identifiers and a persona, never a customer's name, email or address. Staff
// screens read across every tenant, so a careless log line here leaks further
// than the same mistake would in the customer app.
initTelemetry();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </AuthProvider>
  </StrictMode>,
);
